import { createFileRoute } from "@tanstack/react-router"
import { AssetTypeSettingsView } from "src/views/AssetTypeSettingsView/AssetTypeSettingsView"
import { assetTypeSettingsStaticData } from "src/views/AssetTypeSettingsView/constants"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/asset-types/")({
	component: AssetTypeSettingsView,
	staticData: assetTypeSettingsStaticData,
})
